export const normalizeWhatsAppNumber = (value?: string): string | null => {
  const digits = (value || '').replace(/\D/g, '');
  if (!digits) return null;
  const withCountryCode = digits.startsWith('977') ? digits :
    (digits.startsWith('98') || digits.startsWith('97') ? `977${digits}` : digits);
  return /^\d{8,15}$/.test(withCountryCode) ? withCountryCode : null;
};

export const whatsappUrl = (number: string | undefined, message: string): string | null => {
  const normalized = normalizeWhatsAppNumber(number);
  return normalized ? `https://wa.me/${normalized}?text=${encodeURIComponent(message)}` : null;
};
